
Greenmile.RouteProgress = Greenmile.RouteProgress || {};

Greenmile.RouteProgress.Utils = function () {

    this.setDataToCollection = function (collection) {
        collection.models.forEach(model => {
            const stops = model.get('route').stops || [];
            var convertedStops = this.convertDateTimeToMilliseconds(stops);
            model.set({stops: convertedStops});
        });

        return collection;
    };

    this.convertDateTimeToMilliseconds = function (stops) {

        var getDateInMilliSeconds = function (date) {
            return Monet.Format.DateTime.parse(date).getTime();
        };

        var fieldsDate = [
            'plannedArrival',
            'plannedDeparture',
            'plannedService',
            'projectedArrival',
            'projectedDeparture',
            'projectedService',
            'actualArrival',
            'actualDeparture',
            'actualService'
        ];

        for (var index = 0, l = stops.length; index < l; index++) {

            for (var key in fieldsDate) {

                var property = fieldsDate[key];

                if (stops[index][property]) {
                    stops[index][property] = getDateInMilliSeconds(stops[index][property]);
                } else {
                    stops[index][property] = null;
                }

            }

        }

        return stops;

    };

    this.getTimeBound = function (routesCollection) {
        let bound = {
            min: 0,
            max: 0
        };

        routesCollection.models.forEach(model => {
            const stops = model.get("stops");
            if (stops) {
                for (let stopIndex = 0; stopIndex < stops.length; stopIndex++) {
                    for (let attribute in stops[stopIndex]) {
                        bound = this.collectMinBax(stops[stopIndex], attribute, bound);
                    }
                }
            }
        });
        return bound;
    };

    this.collectMinBax = function (stop, attribute, bound) {

        if (this.checkIfIsTimeAttribute(attribute)) {
            bound.min = this.checkIfIsMin(stop[attribute], bound.min);
            bound.max = this.checkIfIsMax(stop[attribute], bound.max);
        }

        App.Forms.RouteProgress.bound = bound;

        return bound;

    };

    this.checkIfIsTimeAttribute = function (attribute) {
        switch (attribute) {
            case 'projectedDeparture':
            case 'projectedService':
            case 'actualDeparture':
                return true;
            default:
                return false;
        }
    };

    this.checkIfIsMin = function (value, min) {

        if (value !== null && (min === 0 || value < min)) {
            return value;
        }

        return min;
    };

    this.checkIfIsMax = function (value, min) {

        if (value > min) {
            return value;
        }

        return min;
    };

    this.getDuration = function (timeMillis) {
        var units = [
            { label: "millis", mod: 1000 },
            { label: "seconds", mod: 60 },
            { label: "minutes", mod: 60 },
            { label: "hours", mod: 24 },
            { label: "days", mod: 7 },
            { label: "weeks", mod: 52 }
        ];
        var duration = {};
        var x = timeMillis;
        for (var i = 0; i < units.length; i++) {
            var tmp = x % units[i].mod;
            duration[units[i].label] = tmp;
            x = (x - tmp) / units[i].mod;
        }
        return duration;
    };

};
